import { render, staticRenderFns } from "./confirm-plan.vue?vue&type=template&id=5cded411&"
import script from "./confirm-plan.vue?vue&type=script&lang=js&"
export * from "./confirm-plan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports